"use client";

import { UserPolicy } from "../../../../lib/types/enums/UserPolicy";
import { useUserPolicy } from "../useUserPolicy";

export const useIsBlockedFromPurchasing = (): boolean =>
  useUserPolicy(UserPolicy.blockedFromPurchasing);
